module.exports = __webpack_public_path__ + "static/media/pathhi.43799b00.ogg";